import { type IReduxStateProvider } from '../IReduxStateProvider';

import { ReduxState } from './ReduxState';

export class NodeReduxState extends ReduxState implements IReduxStateProvider {
  public constructor() {
    super(undefined, false);
  }
}
